var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, CustomElement, Event, html } from '@sick-davinci/ce-decorators';
import { style } from './FileChooser.style';
import { Button } from '../button/Button';
/**
 * A `davinci-file-chooser` opens the systems file dialog and lets the user choose one or multiple files.
 * The `davinci-file-chooser` is shown as `<davinci-button>`.
 * 
 * The button styles can be influenced using the `button-type` attribute.
 * 
 * @example
 * ```html
 *  <davinci-file-chooser multiple accept=".jpg, .png">Select images</davinci-file-chooser>
 *  ```
 * @slot {*} defines the content of the button (usually text)
 */

export let FileChooser = (_dec = Component({
  style,
  tag: 'davinci-file-chooser',
  dependencies: [Button]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Boolean), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop({
  type: String
}), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", Object), _dec20 = Event(), _dec21 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class FileChooser extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "value", _descriptor, this);

    _initializerDefineProperty(this, "accept", _descriptor2, this);

    _initializerDefineProperty(this, "multiple", _descriptor3, this);

    _initializerDefineProperty(this, "disabled", _descriptor4, this);

    _initializerDefineProperty(this, "name", _descriptor5, this);

    _initializerDefineProperty(this, "buttonType", _descriptor6, this);

    _initializerDefineProperty(this, "icon", _descriptor7, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor8, this);

    _initializerDefineProperty(this, "change", _descriptor9, this);

    _defineProperty(this, "_fileList", null);

    _defineProperty(this, "onFileSelect", event => {
      event.preventDefault();
      event.stopPropagation();
      this._fileList = event.currentTarget.files;
      this.change.emit(this._fileList); // Fix for selecting a file two times in a row, otherwise the change event won't be fired

      this.shadowRoot.querySelector('input').value = '';
    });

    _defineProperty(this, "onClick", _event => {
      this.shadowRoot.querySelector('input').click();
    });
  }

  /**
   * Get the list of selected files.
   */
  get files() {
    return this._fileList;
  }
  /**
   * Emitted the [FileList](https://developer.mozilla.org/en-US/docs/Web/API/FileList) object when the user selected one or more files.
   */


  render() {
    return html`
      <div class="container">
        <davinci-button
          type="${this.buttonType}"
          ?disabled="${this.disabled}"
          icon="${this.icon}"
          icon-src="${this.iconSrc}"
          @click="${this.onClick}"
        >
        <slot></slot>
        </davinci-button>
        <input
          type="file"
          value="${this.value}"
          accept="${this.accept}"
          ?multiple="${this.multiple}"
          ?disabled="${this.disabled}"
          @change="${this.onFileSelect}"
        />
      </div>
    `;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "accept", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "multiple", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "buttonType", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'primary';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "files", [_dec18, _dec19], Object.getOwnPropertyDescriptor(_class2.prototype, "files"), _class2.prototype), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
